import { render, staticRenderFns } from "./insGoldenSampleFeature.vue?vue&type=template&id=6d690f40&"
import script from "./insGoldenSampleFeature.vue?vue&type=script&lang=js&"
export * from "./insGoldenSampleFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports